import ButtonCircle from '../ButtonCircle';
import Card from '../Card';
import { CardDescription, CardInner, CardTitle } from '../Card/Card';
import SearchForm from './SearchForm';

export type SearchResultProps = {
  emptyResultsMessage?: string;
  within?: string;
  helpCentreUrl?: string;
  contactUrl?: string;
};

const SearchResults: React.FC<SearchResultProps> = ({
  helpCentreUrl,
  contactUrl,
}) => (
  <div className="bg--mist">
    <div className="page-header page-header--search">
      <div className="page-header__text container">
        <h1
          className="page-header__title"
          data-testid="PageHeader__Title"
          data-aos="fade-in"
          data-aos-delay="100"
        >
          Search
        </h1>

        <SearchForm
          showFacets
          hasHits
          hasHelpCentre={helpCentreUrl && helpCentreUrl.length > 0}
        />
      </div>
    </div>

    <div className="search-results hidden">
      <div className="container">
        <div className="search-results__container">
          <div className="search-results__aside">
            <div id="stats" />
          </div>

          <div className="search-results__results">
            <div id="hits" />
            <div id="pagination" />

            <div className="search-results__footer">
              {helpCentreUrl && (
                <Card href={helpCentreUrl}>
                  <CardInner>
                    <CardTitle large>Browse the help centre</CardTitle>
                    <CardDescription>
                      Explore our help articles to find answers to commonly
                      asked questions
                    </CardDescription>
                  </CardInner>
                  <span className="button--secondary-alt">
                    <ButtonCircle
                      arrowFill="#ffffff"
                      arrowHeight={16}
                      arrowWidth={16}
                    />
                  </span>
                </Card>
              )}
              {contactUrl && (
                <Card href={contactUrl}>
                  <CardInner>
                    <CardTitle large>Contact us</CardTitle>
                    <CardDescription>
                      We’ll connect you with a specialist to help with whatever
                      you need.
                    </CardDescription>
                  </CardInner>
                  <span className="button--secondary-alt">
                    <ButtonCircle
                      arrowFill="#ffffff"
                      arrowHeight={16}
                      arrowWidth={16}
                    />
                  </span>
                </Card>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SearchResults;
